import React, { Component } from "react";
import { connect } from "react-redux";
import { SiteConstants } from "../../../constants/constant";
import { IsEmpty } from "../../../util/commonFunctions";
import { isPlayerLoaded } from "../../../actions/index";
import { getEnv } from "../../../../helpers/env";
// index
let i = 0;
let playerInterval;
let changeDetails;
const url =
  typeof window !== "undefined" ? window.location.href.split("/") : "";


class Player extends Component {
  constructor(props) {
    super(props);
    this.state = {
      player: null,
    };

    this.playerConfig = {
      key: SiteConstants.bitmovinPlayerKey,
      analytics: {
        key:
          getEnv("ANALYTICS").toLowerCase() == "dev"
            ? null
            : SiteConstants.bitmovinAnalyticsKey,
      },
      remotecontrol: {
        type: "googlecast",
        customReceiverConfig: {
          receiverStylesheetUrl:
            url[0] + "//" + url[2] + "/assets/css/bitmovinWaterMark.css",
        },
      },

      playback: {
        autoplay: true,
        muted: true,
        volume: 50,
      },
      events: {
        playbackfinished: function () {
          changeDetails(parseInt(i) + 1);
        },

        ready: function () { },
      },
      style: {
        width: "100%",
        aspectratio: "16:9",
      },
    };

    console.log("Player config", this.playerConfig)
  }

  getCommonAnalytics = () => {
    return {
      userId: this.props.userProfile && this.props.userProfile.id,
      customData3: this.props.userProfile
        ? this.props.userProfile.whatDoYouDo?.name
        : null,
      customData4: this.props.userProfile
        ? this.props.userProfile.whereDoYouInvest?.name
        : null,
    };
  };

  getVodAnalytics = (vodData) => {
    return {
      title: vodData ? vodData.title : null,
      videoId: vodData ? vodData.id : null,
      customData1: vodData ? vodData.topic.name : null,
    };
  };

  getLiveStreamAnalytics = (isLive, liveData, epgSlideNumber) => {
    return {
      title:
        isLive && liveData && liveData[epgSlideNumber]
          ? liveData[epgSlideNumber].show
          : null,
      videoId: "AusbizLiveTV",
      customData2:
        isLive && liveData && liveData[epgSlideNumber]
          ? liveData[epgSlideNumber].guest
          : null,
    };
  };

  componentDidMount() {
    this.setupPlayer();
  }

  componentWillUnmount() {
    clearInterval(playerInterval);
    this.destroyPlayer();
  }

  getPlayerTime = () => {
    if (
      this.state.player &&
      Math.ceil(this.state.player.getCurrentTime()) >=
      this.props.playerTimeout &&
      IsEmpty(this.props.token) &&
      this.state.player
    ) {
      clearInterval(playerInterval);
      this.state.player.castStop();
      this.props.enableOverlayFun();
      this.state.player.pause();
    } else if (!IsEmpty(this.props.token)) {
      clearInterval(playerInterval);
    }
    if (this.state.player) {
      localStorage.setItem("lastVideoSeek", this.state.player.getCurrentTime());
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.currentVodId != this.props.currentVodId) {
      this.state.player.pause();
      let playerSource = { ...this.props.videoUrl };
      i = this.props.currentPlayingIndex && this.props.currentPlayingIndex;
      let analytics = {
        ...this.getVodAnalytics(this.props.showVod),
        ...this.getCommonAnalytics(),
      };

      this.playerSetup(playerSource, analytics);

      if (IsEmpty(this.props.token)) {
        playerInterval = setInterval(this.getPlayerTime, 2000);
      }
    }
    if (this.props.livePlayer && !this.props.playVideo && this.state.player) {
      this.state.player.pause();
    }
  };

  setupPlayer() {
    console.log("Setting up player...");
    let analytics = { ...this.getCommonAnalytics() };
    let playerSource = { ...this.props.videoUrl };
    console.log("Video URL", this.props.videoUrl);
    changeDetails = this.props.changeVodDetails && this.props.changeVodDetails;

    if (!this.props.playVideo) {
      this.playerConfig.playback.autoplay = false;
    }
    if (this.props.playerLoaded) {
      this.playerConfig.playback.muted = false;
    }
    this.props.isPlayerLoaded();
    if (this.props.livePlayer) {
      playerSource = {
        dash: "",
        hls: this.props.videoUrl,
        progressive: "",
      };
      analytics = {
        ...analytics,
        ...this.getLiveStreamAnalytics(
          this.props.showLive,
          this.props.data[0].data,
          this.props.startPosition
        ),
      };
      let refrence = this;
      if (IsEmpty(this.props.token)) {
        setTimeout(() => {
          if (IsEmpty(refrence.props.token) && refrence.state.player) {
            refrence.state.player.castStop();
            refrence.props.enableOverlayFun();
            refrence.state.player.pause();
          }
        }, this.props.playerTimeout * 1000);
      }
    } else {
      analytics = {
        ...analytics,
        ...this.getVodAnalytics(this.props.showVod),
      };
      if (IsEmpty(this.props.token)) {
        playerInterval = setInterval(this.getPlayerTime, 2000);
      }
    }
    this.playerSetup(playerSource, analytics);
  }

  playerSetup = (playerSource, analytics) => {
    console.log("Player state", this.state.player)
    if (!this.state.player) {
      const player = new bitmovin.player.Player(
        document.getElementById("player"),
        this.playerConfig
      );
      console.log("Player source config", playerSource)
      console.log("ANALYTICS", analytics);
      if (getEnv("ANALYTICS").toLowerCase() == "dev") {
        console.log("IS DEV");
        player
          .load({
            ...playerSource,
          })
          .then(
            () => {
              this.setState({
                ...this.state,
                player,
              });
              if (this.props.playVideo) {
                // player.currentTime = 30;
                player.seek(this.props.startPosition);
                player.play();
              }
            },
            () => { }
          ).catch((e) => {
            console.error("Error", e);
          });;
      } else {
        console.log("Player source config - ELSE", playerSource)
        player
          .load({
            ...playerSource,
            ...{ analytics },
          })
          .then(
            () => {
              this.setState({
                ...this.state,
                player,
              });
              if (this.props.playVideo) {
                player.play();
              }
            },
            () => { }
          ).catch((e) => {
            console.error("Error", e);
          });
      }
    } else {
      console.log("ANALYTICS", getEnv("ANALYTICS"));
      if (getEnv("ANALYTICS").toLowerCase() == "dev") {
        console.log("Player source when DEV", playerSource)
        this.state.player
          .load({
            ...playerSource,
          })
          .then(
            () => {
              this.state.player.play();
            },
            () => { }
          ).catch((e) => {
            console.error("Error", e);
          });;
      } else {
        this.state.player
          .load({
            ...playerSource,
            ...{ analytics },
          })
          .then(
            () => {
              this.state.player.play();
            },
            () => { }
          ).catch((e) => {
            console.error("Error", e);
          });;
      }
    }
  };

  destroyPlayer() {
    if (this.state.player != null) {
      this.state.player.destroy();
      this.setState({
        ...this.state,
        player: null,
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div id="player" />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  console.log("Player loaded: ", state.auth.playerLoaded);
  return {
    playerLoaded: state.auth.playerLoaded,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    isPlayerLoaded: () => dispatch(isPlayerLoaded()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Player);
